import React from 'react';
import { path } from 'ramda';
import { useSelector } from 'react-redux';
import { useGetTags } from 'js/hooks/useGetTags';
import { AUTH_REDUCER } from 'js/store/constants';
import { Loader } from 'js/components/common/Loader';
import { usePublicApi } from 'js/hooks/usePublicAPI';
import { Reconnect } from 'js/components/main/Reconnect';
import { useDetectLanguage, useGeoIP, useUserKeepAlive } from 'js/hooks/user';
import { TagManager } from 'js/components/system/TagManager';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { PopupManager } from 'js/components/common/PopupManager';
import { usePas, useAutoLogin, useSessionRestore } from 'js/hooks/auth';
import { usePushNotifier, useAppNotifier, useOnDeviceChange } from 'js/components/system/App/hooks';
import { useOAPISocket } from 'server';

import * as hooks from './hooks';
import { WrapperInner } from './components/WrapperInner';

import style from './Wrapper.scss';

export const Wrapper = () => {
    const [{ isLoading: isTagsLoading }] = useGetTags();
    const [{ error, isLoading: isAppLoading }] = hooks.useWrapperAppInitialResources();
    const wasAutoLoginCompleted = useSelector(path([AUTH_REDUCER, 'wasAutoLoginCompleted']));
    const isReady = !isAppLoading && !isTagsLoading && wasAutoLoginCompleted;

    usePas();
    useAutoLogin();
    useSessionRestore();
    useGeoIP();
    useUserKeepAlive();
    useDetectLanguage();
    useOAPISocket();
    useUserKeepAlive();
    useAppNotifier();
    usePublicApi();
    usePushNotifier();
    useOnDeviceChange();

    if (!isReady) {
        return <Loader />;
    }

    if (error) {
        const errorMessage = typeof error === 'string' || error instanceof window.Error
            ? error.toString()
            : 'Error loading';

        return <ErrorMessage className={style.error} message={errorMessage} />;
    }

    return (
        <>
            <WrapperInner />
            <TagManager isWrapper={true} />
            <Reconnect />
            <PopupManager />
        </>
    );
};
